<template>
  <div class="pd-audioInfoBigWrapper">
    <div v-if="getLoadedState" class="pd-silenceWrapper">
      <div class="pd-silenceToggle" @click="expand = !expand">
        <ForwardArrowIcon v-if="expand" />
        <BackArrowIcon v-else />
      </div>
      <v-expand-x-transition>
        <div v-show="expand" class="pd-silenceCard" height="110" width="100">
          <div class="pd-silenceContainer">
            <div class="pd-silenceTitle">
              {{ $t("audioInfo.silenceTitle") }}
            </div>
            <div class="pd-silenceSubTitle">
              {{ $t("audioInfo.silenceSubTitle") }}
            </div>
            <input
              type="number"
              min="0.1"
              max="90"
              step="0.1"
              class="pd-silenceDuration"
              v-model="silence"
            />
            <div @click="updateSilence" class="pd-silenceAction">
              {{ $t("audioInfo.silenceAction") }}
            </div>
          </div>
        </div>
      </v-expand-x-transition>
    </div>
    <div
      :id="projectId"
      class="pd-audioInfoWrapper"
      :class="focus ? 'pd-focusBorder' : ''"
      @click="showAudioInfo()"
    >
      <div class="pd-audioInfoHeadWrapper">
        <div v-if="getLoadedState" class="pd-audioTime">
          <span style="height: 24px; margin-right: 5px"><TimeIcon /></span>
          {{ data.duration }} {{ $t("audioInfo.sec") }}
        </div>
        <div v-else-if="status === 'audio_building'">
          {{ $t("audioInfo.audioBuilding") }}
        </div>
        <div v-else>
          <v-progress-circular
            class="pd-progressStyle"
            :rotate="-90"
            :size="30"
            :width="3"
            :value="percent"
            color="green"
            >{{ percent }}%</v-progress-circular
          >
        </div>
      </div>
      <div class="pd-audioName">{{ name }}</div>
      <div>
        <div class="pd-inputType">
          <div style="margin-right: 5px">
            <FileInputIcon
              v-if="data.type == 'file'"
              width="11"
              height="11"
              color="#98A7AD"
            />
            <TextInputIcon v-else width="11" height="11" color="#98A7AD" />
          </div>
          {{
            data.type === "text"
              ? $t("audioInfo.handWritten")
              : $t("audioInfo.readFromFile")
          }}
        </div>
        <div class="pd-date">
          <div style="margin-right: 5px">
            <DateIcon />
          </div>
          {{ getFormatDate }}
        </div>
      </div>
      <div class="pd-hoverWrapper">
        <SeeIcon />
        <div class="pd-hoverTitle">
          {{
            focus ? $t("audioInfo.hoverTitle1") : $t("audioInfo.hoverTitle2")
          }}
        </div>
      </div>
      <v-menu bottom left min-width="140px" max-width="140px" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn class="pd-thingsBtn" v-on="on"><MenuIcon /></v-btn>
        </template>
        <v-list>
          <v-list-item-content class="align-center">
            <v-list-item class="pd-listItem" @click="updateName">
              <EditIcon :width="18" :height="18" />
              <div class="pd-editName">{{ $t("audioInfo.editName") }}</div>
            </v-list-item>
            <v-list-item class="pd-listItem" @click="deleteAudio">
              <div style="color: #d23636">
                <DeleteIcon :width="18" :height="18" />
              </div>
              <div class="pd-deleteProject">
                {{ $t("audioInfo.deleteProj") }}
              </div>
            </v-list-item>
          </v-list-item-content>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { format } from "date-fns";
import MenuIcon from "../components/icons/MenuIcon";
import TimeIcon from "../components/icons/TimeIcon";
import FileInputIcon from "../components/icons/FileInputIcon";
import TextInputIcon from "../components/icons/TextInputIcon";
import DateIcon from "../components/icons/DateIcon";
import BackArrowIcon from "../components/icons/BackArrowIcon";
import ForwardArrowIcon from "../components/icons/ForwardArrowIcon";
import SeeIcon from "../components/icons/SeenIcon";
import EditIcon from "../components/icons/EditIcon";
import DeleteIcon from "../components/icons/DeleteIcon";
import { mapActions } from "vuex";
export default {
  name: "AudioInfo",
  components: {
    TimeIcon,
    FileInputIcon,
    TextInputIcon,
    BackArrowIcon,
    ForwardArrowIcon,
    DateIcon,
    SeeIcon,
    MenuIcon,
    EditIcon,
    DeleteIcon,
  },
  props: {
    focus: { type: Boolean },
    name: { type: String },
    percent: { type: Number },
    index: { type: Number },
    status: { type: String },
    projectId: { type: Number },
    data: { type: Object },
    deleteAudioShowDialog: { type: Function },
    editAudioShowDialog: { type: Function },
    showProjectInfo: { type: Function },
  },
  data: () => ({
    toggleBtn: false,
    play: false,
    token: "",
    expand: false,
    project: null,
    silence: 0,
  }),
  computed: {
    getLoadedState: function() {
      return this.status === "synthesized";
    },
    getToken: function() {
      return this.$cookie.get("token");
    },
    getFormatDate: function() {
      var currentDate = new Date(this.data.synthesized_date);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
  },
  mounted() {
    this.silence = this.data.silence / 1000;
  },
  methods: {
    ...mapActions([
      "changeSelectedProject",
      "showSuccessMessage",
      "showErrorMessage",
      "checkError",
    ]),
    updateSilence() {
      var headers = { token: this.getToken };
      axios
        .put(
          `${process.env.VUE_APP_BASE_URL}/v2/project/` +
            this.projectId +
            "/silence",
          this.silence * 1000,
          { headers }
        )
        .then((response) => {
          if (response.status === 200) {
            this.showSuccessMessage({
              message: this.$t("audioInfo.successMsg1"),
              timeout: 3000,
            });
            this.expand = false;
          } else {
            this.showErrorMessage({
              message: this.$t("audioInfo.errorMsg1"),
              timeout: 3000,
            });
          }
        });
    },

    /* Хөрвүүлэгдсэн аудиог татаж авах функц*/
    download(path) {
      var url = `${process.env.VUE_APP_BASE_URL}/` + path;
      var headers = { token: this.getToken };

      axios({
        url: url,
        headers: headers,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", url.split("/").pop());
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((error) => {
          this.checkError(error);
        });
    },

    /* Аудио бичлэгийн нэрийг солих функц */
    updateName() {
      this.editAudioShowDialog(this.data.id, this.index);
    },

    /* Аудио бичлэгийг устгах функц */
    deleteAudio() {
      this.deleteAudioShowDialog(this.data.id);
    },

    showAudioInfo() {
      if (this.focus != true) {
        this.showProjectInfo(this.data.id, this.index);
        //this.changeSelectedProject(this.data);
      }
    },

    showRemoveDialog() {
      event.stopPropagation();
      this.removeDialog = true;
    },
  },
};
</script>
<style scoped>
.pd-audioInfoWrapper {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 200px;
  min-height: 120px;
  max-height: 120px;
  padding: 10px 15px 5px 15px;
  background-color: #ffffff;
  border-radius: 7px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  justify-content: space-between;
  position: relative;
}

.pd-audioInfoWrapper:hover {
  background: rgba(0, 0, 0, 0.71);
  border-radius: 7px;
}

.pd-hoverWrapper {
  visibility: hidden;
  position: absolute;
  display: flex;
  height: 100px;
  width: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: 50%;
  margin-top: -50px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
}

.pd-hoverTitle {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}

.pd-audioInfoWrapper:hover .pd-hoverWrapper {
  visibility: visible;
}

.pd-audioInfoHeadWrapper {
  display: flex;
  align-items: center;
  height: 25px;
}

.pd-audioTime {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
}

.pd-audioName {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin: 5px 0px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 170px;
}

.pd-inputType,
.pd-date {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #767676;
}

.pd-focusBorder {
  border: 1px solid #777ff6;
}

.pd-thingsBtn {
  position: absolute;
  top: 5px;
  right: 0;
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 22px !important;
  min-width: 22px !important;
  padding: 0 !important;
}
.pd-silenceAction {
  color: white;
  padding: 4px 16px;
  margin-top: 4px;
  border-radius: 4px;
  font-size: 14px;
  background-color: #777ff6 !important;
}
.pd-thingsBtn:hover {
  border: 2px solid #e5e5e5;
  background: rgba(0, 0, 0, 0.71);
}

.pd-dialogWrapper {
  padding: 31px 38px;
}

@media screen and (max-width: 768px) {
  .pd-dialogWrapper {
    padding: 20px;
  }
}

.pd-dialogTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.pd-dialogTitle {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin-left: 5px;
}

.pd-dialogWarn {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  margin-bottom: 10px;
}

.pd-inputWrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 56px;
}
.pd-inputWrapper input[type="text"] {
  height: 40px !important;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  font-weight: 400;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.pd-inputWrapper input[type="text"]:focus {
  border: 2px solid #777ff6 !important;
  outline: none;
}

.pd-inputWrapper input[type="text"]:hover {
  border: 2px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.pd-errorInput {
  font-size: 12px;
  line-height: 14px;
  color: red;
  margin: 2px 0 0 10px;
}

.pd-dialogActionWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.pd-closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 15px;
  height: 34px !important;
  width: 64px !important;
}
.pd-silenceContainer {
  padding: 5px;
}
.pd-changeBtn {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.v-menu__content {
  border: 1px solid #e5e5e5 !important;
  background-color: #ffffff;
  border-radius: 6px !important;
  box-shadow: none !important;
  padding-top: 0 !important;
  box-shadow: 0px 9px 16px rgba(0, 0, 0, 0.06) !important;
}

.v-list {
  padding: 0;
}

.v-list-item__content {
  padding: 0;
}

.pd-listItem {
  border-bottom: 1px solid #e5e5e5;
}

.pd-editName {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #000000;
  margin-left: 10px;
}

.pd-deleteProject {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #d23636;
  margin-left: 10px;
}

.pd-progressStyle {
  font-size: 12px;
  font-weight: 500;
}

.pd-silenceWrapper {
  display: flex;
  align-items: center;
}
.pd-audioInfoBigWrapper {
  display: flex;
}

.pd-silenceToggle {
  display: flex;
  align-items: center;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
  width: 20px;
  height: 30px;
  background-color: #eff0fd;
}

.pd-silenceDuration {
  width: 100%;
  border: solid 1px #e5e5e5;
  border-radius: 3px !important;
  font-size: 14px;
}

.pd-silenceCard {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 7px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
}

.pd-silenceTitle {
  font-size: 14px;
}

.pd-silenceSubTitle {
  font-size: 14px;
  color: #767676;
}
</style>
